import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  gridImageWrap: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: props => props?.width,
    height: props => props?.height,
    background: (props => props?.texture ? null : (props?.bgColor !== 'transparent' ? props?.bgColor : 'var(--transparent-background-image)')),
  },
  gridImageBox: {
    width: props => props.boxWidth || '100%',
    height: props => props.boxHeight || '100%',
  },
  gridImage: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
});

export default useStyles;
